import { createSlice } from '@reduxjs/toolkit';
// utils
import axios from '../../utils/axios';
//
import { dispatch } from '../store';

// ----------------------------------------------------------------------

const initialState = {
    isJobMastersLoading: false,
    isPhaseGroupLoading: false,
    isJobPhaseLoading: false,
    error: null,
    job_masters: null,
    phaseGroups: null,
    jobPhases: null,
};

const slice = createSlice({
    name: 'job_master',
    initialState,
    reducers: {
        // START LOADING
        startJobMastersLoading(state) {
            state.isJobMastersLoading = true;
        },
        // START LOADING
        startPhaseGroupLoading(state) {
            state.isPhaseGroupLoading = true;
        },
        // START LOADING
        startJobPhaseLoading(state) {
            state.isJobPhaseLoading = true;
        },
        // HAS ERROR
        hasError(state, action) {
            state.isJobMastersLoading = false;
            state.error = action.payload;
        },

        // GET JOB MASTERS
        setJobMasters(state, action) {
            state.isJobMastersLoading = false;
            state.job_masters = action.payload;
        },

        // GET JOB MASTERS
        setPhaseGroup(state, action) {
            state.isPhaseGroupLoading = false;
            state.phaseGroups = action.payload;
        },

        setJobPhase(state, action) {
            state.isJobPhaseLoading = false;
            state.jobPhases = action.payload;
        },
    },
});

// Reducer
export default slice.reducer;

// Actions
export const {
    startJobMastersLoading,
    startPhaseGroupLoading,
    hasError,
} = slice.actions;

// ----------------------------------------------------------------------
export function getJobMaster(params = {}, fetchUrl = "/dropdown/job/job_masters") {
    return async () => {
        dispatch(slice.actions.startJobMastersLoading());
        try {
            const response = await axios.get(fetchUrl, {
                params: params
            });
            dispatch(slice.actions.setJobMasters(response.data));
        } catch (error) {
            dispatch(slice.actions.hasError(error));
        }
    };
}

export function getJobMasterAvailable(params = {}, fetchUrl = "/admin/job/dropdown/available_Jobs") {
    return async () => {
        dispatch(slice.actions.startJobMastersLoading());
        try {
            const response = await axios.get(fetchUrl, {
                params: params
            });
            dispatch(slice.actions.setJobMasters(response.data));
        } catch (error) {
            dispatch(slice.actions.hasError(error));
        }
    };
}

export function getPhaseGroups(params = {}, fetchUrl = "/admin/job_cost/phase_groups") {
    return async () => {
        dispatch(slice.actions.startPhaseGroupLoading());
        try {
            const response = await axios.get(fetchUrl, {
                params: params
            });
            dispatch(slice.actions.setPhaseGroup(response.data));
        } catch (error) {
            dispatch(slice.actions.hasError(error));
        }
    };
}


export function getJobPhases(params = {}, fetchUrl = "/dropdown/job/job_phases") {
    return async () => {
        dispatch(slice.actions.startJobPhaseLoading());
        try {
            const response = await axios.get(fetchUrl, {
                params: params
            });
            dispatch(slice.actions.setJobPhase(response.data));
        } catch (error) {
            dispatch(slice.actions.hasError(error));
        }
    };
}